import { get } from '@lumapps/constants';

const Config = get();

const DEFAULT_LANGUAGE = Config.defaultLanguage;

const SCOPE = 'languages';

export { DEFAULT_LANGUAGE, SCOPE };
